function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.699 339.37c17.196 106.964 161.913 126.052 313.342 145.358 344.152 43.877 461.168-388.711 206.92-470.939-154.954-50.114-178.605 46.212-303.262 137.904-77.912 57.308-232.678 90.158-217 187.677z",
  fill: "#F9BB16"
});

function SvgBgYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 659,
    height: 488,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjU5IiBoZWlnaHQ9IjQ4OCIgdmlld0JveD0iMCAwIDY1OSA0ODgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoCiAgICBkPSJNMS42OTkwNCAzMzkuMzdDMTguODk1NCA0NDYuMzM0IDE2My42MTIgNDY1LjQyMiAzMTUuMDQxIDQ4NC43MjhDNjU5LjE5MyA1MjguNjA1IDc3Ni4yMDkgOTYuMDE2NyA1MjEuOTYxIDEzLjc4OTRDMzY3LjAwNyAtMzYuMzI1IDM0My4zNTYgNjAuMDAwNyAyMTguNjk5IDE1MS42OTNDMTQwLjc4NyAyMDkuMDAxIC0xMy45Nzg4IDI0MS44NTEgMS42OTkwNCAzMzkuMzdaIgogICAgZmlsbD0iI0Y5QkIxNiIKICAvPgo8L3N2Zz4K";
export { SvgBgYellow as ReactComponent };